import { render } from "./messagemodals.vue?vue&type=template&id=36b6cd63"
import script from "./messagemodals.vue?vue&type=script&lang=js"
export * from "./messagemodals.vue?vue&type=script&lang=js"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__